var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_906_74",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 3,
    width: 18,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.625 3.5H24.295V28.5H7.625V3.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_906_74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7935 28.5C14.0935 28.5 15.9601 26.6334 15.9601 24.3334V20.1666H11.7935C9.49346 20.1666 7.62671 22.0334 7.62671 24.3334C7.62671 26.6334 9.49346 28.5 11.7935 28.5Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62671 16C7.62671 13.7 9.49346 11.8334 11.7935 11.8334H15.9601V20.1666H11.7935C9.49346 20.1666 7.62671 18.3 7.62671 16Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62671 7.66663C7.62671 5.36663 9.49346 3.5 11.7935 3.5H15.9601V11.8334H11.7935C9.49346 11.8334 7.62671 9.96662 7.62671 7.66663Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9602 3.5H20.1268C22.4268 3.5 24.2936 5.36663 24.2936 7.66663C24.2936 9.96662 22.4268 11.8334 20.1268 11.8334H15.9602V3.5Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2936 16C24.2936 18.3 22.4268 20.1666 20.1268 20.1666C17.8268 20.1666 15.9602 18.3 15.9602 16C15.9602 13.7 17.8268 11.8334 20.1268 11.8334C22.4268 11.8334 24.2936 13.7 24.2936 16Z",
    fill: "#1ABCFE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFigma);
export default __webpack_public_path__ + "static/media/icon_figma.3761339d39991273d4f7602df4553457.svg";
export { ForwardRef as ReactComponent };